import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {
    Box,
    TextField,
    Button,
    Typography,
    Checkbox,
    FormControlLabel,
    Grid,
} from '@mui/material';
import { createArrangeVewing } from '../services/propertyService';
import Toast from "../components/Toast"
import { useLocation } from 'react-router-dom';

const ArrangeViewing = (props) => {
    const location = useLocation();
    const [toastOpen, setToastOpen] = React.useState(false);
    const [toastMessage, setToastMessage] = React.useState("");
    const validationSchema = Yup.object({
        firstname: Yup.string().required('First name is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        number: Yup.string()
            .matches(/^(?:\+91|0)?[6789]\d{9}$/, "Invalid Indian mobile number")
            .required('Contact number is required'),
        message: Yup.string().required('Message is required'),
        terms: Yup.boolean().oneOf(
            [true],
            'You must accept the terms and conditions'
        ),
    });

    const formik = useFormik({
        initialValues: {
            firstname: '',
            lastname: '',
            email: '',
            number: '',
            message: '',
            latestNews: false,
            createAccount: false,
            terms: false,
            propertyUrl: window.location.origin + location.pathname,
        },
        validationSchema,
        onSubmit: (values) => {
            createArrangeVewing(values).then((res) => {
                console.log('Response:', res);
                setToastMessage(res.message);
                setToastOpen(true);
                setTimeout(() => {
                    props.isSubmitted && props?.isSubmitted(false);
                }, 2000);
            })
            .catch((error) => {
                console.error('Error:', error);
                setToastMessage("There was an error submitting the form. Please try again.");
                setToastOpen(true);
            });
        },
    });

    const handleChange = (e) => {
        const { name, checked } = e.target;
        formik.setFieldValue(name, checked);
    }

    return (
        <Box
            sx={{
                maxWidth: 600,
                margin: 'auto',
                padding: 3,
                border: '1px solid #ccc',
                borderRadius: 2,
                boxShadow: 2,
            }}
        >
            <Typography variant="h5" textAlign="center" marginBottom={2}>
                Arrange Viewing
            </Typography>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="firstname"
                            name="firstname"
                            placeholder="First Name"
                            value={formik.values.firstname}
                            onChange={formik.handleChange}
                            error={formik.touched.firstname && Boolean(formik.errors.firstname)}
                            helperText={formik.touched.firstname && formik.errors.firstname}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="lastname"
                            name="lastname"
                            placeholder="Last Name"
                            value={formik.values.lastname}
                            onChange={formik.handleChange}
                            error={formik.touched.lastname && Boolean(formik.errors.lastname)}
                            helperText={formik.touched.lastname && formik.errors.lastname}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="email"
                            name="email"
                            placeholder="Email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="number"
                            name="number"
                            placeholder="Contact Number"
                            value={formik.values.number}
                            onChange={formik.handleChange}
                            error={formik.touched.number && Boolean(formik.errors.number)}
                            helperText={formik.touched.number && formik.errors.number}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            id="message"
                            name="message"
                            placeholder="Message"
                            multiline
                            rows={4}
                            value={formik.values.message}
                            onChange={formik.handleChange}
                            error={formik.touched.message && Boolean(formik.errors.message)}
                            helperText={formik.touched.message && formik.errors.message}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox name="latestNews" checked={formik.values.latestNews} onChange={handleChange} />}
                            label="Get emails with the latest news on the local property market, our products, and services."
                        />
                    </Grid>
                    {/* <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox name="createAccount" checked={formik.values.createAccount} onChange={handleChange} />}
                            label="Create an account to view your saved properties and searches."
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox name="terms" checked={formik.values.terms} onChange={formik.handleChange} />}
                            label="I agree to the terms and conditions"
                        />
                        {formik.touched.terms && formik.errors.terms && (
                            <Typography color="error" variant="body2">
                                {formik.errors.terms}
                            </Typography>
                        )}
                    </Grid>
                </Grid>

                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                        marginTop: 2,
                        backgroundColor: '#d8b035',
                        color: 'white',
                        '&:hover': {
                            backgroundColor: '#c5a02f',
                        },
                        '@media (max-width: 600px)': {
                            fontSize: '1rem',
                        },
                    }}
                >
                    Submit
                </Button>
            </form>
            <Toast
                open={toastOpen}
                message={toastMessage}
                onClose={() => setToastOpen(false)}
                severity={toastMessage.includes('success') ? "success" : "error"}
                autoHideDuration={6000}
            />

        </Box>
    );
};

export default ArrangeViewing;
